import { c as _c } from "react/compiler-runtime";
import { IcoInfo16 } from '@onefootprint/icons';
import type { VaultKind } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
type AutoDecryptingMessageProps = {
  expiresAt: number | null;
  vaultKind: VaultKind;
};
const AutoDecryptingMessage = t0 => {
  const $ = _c(16);
  const {
    expiresAt,
    vaultKind
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "headerDefault.autoDecryptIndicator"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const formatExpirationTime = _temp;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[1] !== expiresAt || $[2] !== t || $[3] !== vaultKind) {
    const timeText = expiresAt ? formatExpirationTime(expiresAt) : "";
    const kind = vaultKind === "person" ? t(_temp2) : t(_temp3);
    t4 = "flex items-center w-fit gap-1";
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <IcoInfo16 color="tertiary" />;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    t2 = "text-body-2 text-tertiary";
    t3 = expiresAt ? t(_temp4, {
      timeText,
      kind
    }) : t(_temp5, {
      kind
    });
    $[1] = expiresAt;
    $[2] = t;
    $[3] = vaultKind;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
  }
  let t6;
  if ($[9] !== t2 || $[10] !== t3) {
    t6 = <p className={t2}>{t3}</p>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t4 || $[13] !== t5 || $[14] !== t6) {
    t7 = <div className={t4}>{t5}{t6}</div>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};
export default AutoDecryptingMessage;
function _temp(timestamp) {
  const date = new Date(timestamp);
  const time = date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true
  });
  const date_str = date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric"
  });
  return `${time}, ${date_str}`;
}
function _temp2($) {
  return $.kind.person;
}
function _temp3($_0) {
  return $_0.kind.business;
}
function _temp4($_1) {
  return $_1.expires;
}
function _temp5($_2) {
  return $_2.enabled;
}